/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Integration_Cta_LedeInputs */

const en_svc_integration_cta_lede = /** @type {(inputs: Svc_Integration_Cta_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tell us what you retype, copy or summarise by hand today. We will check what can connect.`)
};

const lv_svc_integration_cta_lede = /** @type {(inputs: Svc_Integration_Cta_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pastāstiet, ko šodien pārrakstāt, kopējat vai apkopojat ar rokām. Mēs pārbaudīsim, ko var savienot.`)
};

/**
* | output |
* | --- |
* | "Tell us what you retype, copy or summarise by hand today. We will check what can connect." |
*
* @param {Svc_Integration_Cta_LedeInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_integration_cta_lede = /** @type {((inputs?: Svc_Integration_Cta_LedeInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Integration_Cta_LedeInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_integration_cta_lede(inputs)
	return en_svc_integration_cta_lede(inputs)
});